// Статусы набора компетенций для задачи
export const PROJECT_COMPETENCE_SET_STATUS_DEFAULT = 'default';
export const PROJECT_COMPETENCE_SET_STATUS_CONFIRMED = 'confirmed';
export const PROJECT_COMPETENCE_SET_STATUS_REJECTED = 'rejected';
